import {Injectable} from "@angular/core";
import {AbstractSQLService} from "./AbstractSQLService";
import {Projeto} from "../../../domain/Projeto";

@Injectable()
export class ProjetoSQLService extends AbstractSQLService<Projeto>{
    nomeTabela = "projeto"
  agenciavel = true

  override toObject(row: any): Projeto {
        row.metodologias = row.metodologias ? JSON.parse(row.metodologias) : []
        row.campanhas = row.campanhas ? JSON.parse(row.campanhas) : []
        row.arquivos = row.arquivos ? JSON.parse(row.arquivos) : []
        row.inicio = new Date(row.inicio)
        row.fim = new Date(row.fim)
        return row
    }

    // override async findById(id){
    //     const sql = "select p.*, l.nome as local_nome from projeto p left join local l on p.localId = l.id WHERE p.id=?"
    //     const lista = await this.sql.executeSql(sql, id)
    //     return lista.rows.length > 0 ? lista.rows[0] : undefined
    // }


    async getItems() {
        const sql  = "select * from projeto order by nome"
        const collection =  (await this.db.query(sql, [])).values!!
        return collection.map((o: any)=> this.toObject(o))
    }
}
